import { resolveReferenceId } from '../../taskRefactored/tasks.service'

const resolveSubTaskAssigneeId = (assigneeId) =>
    resolveReferenceId(assigneeId?.[0] ?? assigneeId)

export const isSubTaskCompletedValue = (subTask) =>
    subTask?.isCompleted === true ||
    subTask?.status === 'completed' ||
    subTask?.status === 'done'

/** Support quick filters only: Incomplete, Completed, Just my tasks. */
export const hasActiveSupportQuickFilter = (listQuery) => {
    if (!listQuery || typeof listQuery !== 'object') return false
    if (typeof listQuery.isCompleted === 'boolean') return true
    if (
        Array.isArray(listQuery.mineAssignee) &&
        listQuery.mineAssignee.length > 0
    ) {
        return true
    }
    return false
}

export const subTaskMatchesSupportQuickFilter = (subTask, listQuery) => {
    if (!hasActiveSupportQuickFilter(listQuery)) return true

    if (typeof listQuery.isCompleted === 'boolean') {
        if (isSubTaskCompletedValue(subTask) !== listQuery.isCompleted) {
            return false
        }
    }

    if (
        Array.isArray(listQuery.mineAssignee) &&
        listQuery.mineAssignee.length > 0
    ) {
        const assigneeId = resolveSubTaskAssigneeId(subTask?.assigneeId)
        const matchesMine = listQuery.mineAssignee.some(
            (id) => String(id) === String(assigneeId)
        )
        if (!matchesMine) return false
    }

    return true
}

export const filterSupportQuickFilterSubTasks = (
    subTasks,
    listQuery,
    { applyFilter = true } = {}
) => {
    const all = Array.isArray(subTasks) ? subTasks : []
    if (!applyFilter || !hasActiveSupportQuickFilter(listQuery)) return all
    return all.filter((subTask) =>
        subTaskMatchesSupportQuickFilter(subTask, listQuery)
    )
}
